// removed by extract-text-webpack-plugin
module.exports = {"mobileBanner":"MobileBanner__mobileBanner___2PBGL","bannerMessageContainer":"MobileBanner__bannerMessageContainer___3HfrJ","downloadAppBtnContainer":"MobileBanner__downloadAppBtnContainer___3s73l","sunbitLogo":"MobileBanner__sunbitLogo___3okdg","closeBanner":"MobileBanner__closeBanner___jKJX9","bright":"MobileBanner__bright___2DHg1","dark":"MobileBanner__dark___1kt5O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/banners/MobileBanner.scss
// module id = 1227
// module chunks = 0